(function () {
  var NAV_CONTENT_TYPE = 'Shokz for Students Page Nav';
  var BANNER_PASS_BUFFER = 1;

  function trackNavLinkClick(buttonName) {
    var label = (buttonName || '').trim();
    if (!label) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content_category',
      event_parameters: {
        content_type: NAV_CONTENT_TYPE,
        button_name: label
      }
    });
  }

  function getNavLinkLabel(linkEl) {
    return linkEl && linkEl.textContent ? linkEl.textContent.trim() : '';
  }

  function getBannerElement(root) {
    var selector = root.getAttribute('data-banner-selector') || '.section-common-banner-1440';
    var banner = document.querySelector(selector);
    if (banner) return banner;

    var navSection = root.closest('.shopify-section');
    if (!navSection || !navSection.previousElementSibling) return null;

    return navSection.previousElementSibling.querySelector(selector) || navSection.previousElementSibling;
  }

  function hasPassedBanner(root) {
    var banner = getBannerElement(root);
    if (!banner) return false;

    return banner.getBoundingClientRect().bottom <= BANNER_PASS_BUFFER;
  }

  function getScrollOffset(root) {
    if (!root.classList.contains('is-visible')) return 0;

    var bar = root.querySelector('[data-oeh-stu-nav-bar]');
    return bar ? bar.offsetHeight : 0;
  }

  function normalizeTargetClass(targetClass) {
    return (targetClass || '').replace(/^\./, '').trim();
  }

  function getTargetElement(targetClass) {
    var normalizedClass = normalizeTargetClass(targetClass);
    if (!normalizedClass) return null;
    return document.querySelector('.' + CSS.escape(normalizedClass));
  }

  function getNavTargets(root) {
    var targets = [];

    root.querySelectorAll('[data-oeh-stu-nav-target]').forEach(function (link) {
      var targetClass = link.getAttribute('data-oeh-stu-nav-target');
      var section = getTargetElement(targetClass);
      if (!section) return;

      targets.push({
        link: link,
        section: section
      });
    });

    targets.sort(function (a, b) {
      var aTop = a.section.getBoundingClientRect().top + window.pageYOffset;
      var bTop = b.section.getBoundingClientRect().top + window.pageYOffset;
      return aTop - bTop;
    });

    return targets;
  }

  function setActiveNavLink(targets, activeIndex) {
    targets.forEach(function (item, index) {
      var isActive = index === activeIndex;
      item.link.classList.toggle('is-active', isActive);
      item.link.setAttribute('aria-current', isActive ? 'location' : 'false');
    });
  }

  function updateActiveNavLink(root) {
    var targets = root._navTargets;
    if (!targets || !targets.length) return;

    var offset = getScrollOffset(root);
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var activeIndex = 0;

    targets.forEach(function (item, index) {
      var sectionTop = item.section.getBoundingClientRect().top + scrollTop;
      if (scrollTop + offset >= sectionTop - 2) {
        activeIndex = index;
      }
    });

    setActiveNavLink(targets, activeIndex);
  }

  function refreshNavTargets(root) {
    root._navTargets = getNavTargets(root);
    updateActiveNavLink(root);
  }

  function scrollToSectionTarget(targetClass, root) {
    if (!targetClass) return false;

    var target = getTargetElement(targetClass);
    if (!target) return false;

    var top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset(root);

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });

    return true;
  }

  function resolveNavClickTrigger(root, event) {
    var linkItem = event.target.closest('.section-open-eh-stu-nav__link-item');
    if (linkItem && root.contains(linkItem)) {
      var navLink = event.target.closest('.section-open-eh-stu-nav__link');
      if (navLink && linkItem.contains(navLink)) {
        return navLink;
      }
    }

    var button = event.target.closest('.section-open-eh-stu-nav__button[data-oeh-stu-nav-target]');
    if (button && root.contains(button)) {
      return button;
    }

    return null;
  }

  function initNavLinks(root) {
    root.addEventListener('click', function (event) {
      var trigger = resolveNavClickTrigger(root, event);
      if (!trigger) return;

      trackNavLinkClick(getNavLinkLabel(trigger));

      if (!trigger.hasAttribute('data-oeh-stu-nav-target')) return;

      event.preventDefault();
      scrollToSectionTarget(trigger.getAttribute('data-oeh-stu-nav-target'), root);

      if (root._navTargets) {
        var activeIndex = root._navTargets.findIndex(function (item) {
          return item.link === trigger;
        });
        if (activeIndex !== -1) {
          setActiveNavLink(root._navTargets, activeIndex);
        }
      }
    });
  }

  function toggleHeaderSuppressed(isSuppressed) {
    document.body.classList.toggle('oeh-stu-nav-replaces-header', isSuppressed);

    document.querySelectorAll('.section-header, .site-header').forEach(function (headerEl) {
      headerEl.classList.toggle('oeh-stu-nav-suppressed', isSuppressed);
    });
  }

  function setNavVisible(root, isVisible) {
    var bar = root.querySelector('[data-oeh-stu-nav-bar]');
    root.classList.toggle('is-visible', isVisible);
    root.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    toggleHeaderSuppressed(isVisible);

    if (bar) {
      bar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      bar.style.top = isVisible ? '0px' : '';
    }
  }

  function updateNavVisibility(root) {
    var bar = root.querySelector('[data-oeh-stu-nav-bar]');
    if (!bar) return;

    var shouldShow = hasPassedBanner(root);
    var isVisible = root.classList.contains('is-visible');

    if (shouldShow !== isVisible) {
      setNavVisible(root, shouldShow);
    } else if (shouldShow) {
      bar.style.top = '0px';
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.navInitialized === 'true') return;
    root.dataset.navInitialized = 'true';

    var onScroll = function () {
      updateNavVisibility(root);
      updateActiveNavLink(root);
    };

    var onResize = function () {
      clearTimeout(root._navResizeTimer);
      root._navResizeTimer = setTimeout(function () {
        updateNavVisibility(root);
        refreshNavTargets(root);
      }, 150);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    root._navOnScroll = onScroll;
    root._navOnResize = onResize;

    initNavLinks(root);
    refreshNavTargets(root);
    setNavVisible(root, false);
    updateNavVisibility(root);
  }

  function destroyRoot(root) {
    if (!root) return;

    if (root._navOnScroll) {
      window.removeEventListener('scroll', root._navOnScroll);
      delete root._navOnScroll;
    }
    if (root._navOnResize) {
      window.removeEventListener('resize', root._navOnResize);
      delete root._navOnResize;
    }
    if (root._navResizeTimer) {
      clearTimeout(root._navResizeTimer);
      delete root._navResizeTimer;
    }

    setNavVisible(root, false);
    toggleHeaderSuppressed(false);
    root.querySelectorAll('.section-open-eh-stu-nav__link.is-active').forEach(function (link) {
      link.classList.remove('is-active');
      link.setAttribute('aria-current', 'false');
    });
    delete root._navTargets;
    delete root.dataset.navInitialized;
  }

  function initAll() {
    document.querySelectorAll('[data-oeh-stu-nav-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-nav-root]');
    if (!root) return;
    destroyRoot(root);
    initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-nav-root]');
    if (!root) return;
    destroyRoot(root);
  });
})();
